<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.attribute.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.title }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="attribute.title"
                      />

                      <form-error
                        :model="$v.attribute.title"
                        :label="translations.forms.labels.title"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.attribute.displayName.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.displayName }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.displayName"
                        v-model="attribute.displayName"
                      />

                      <form-error
                        :model="$v.attribute.displayName"
                        :label="translations.forms.labels.displayName"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.description }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.description"
                        v-model="attribute.description"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.attribute.attributeStyle.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.attributeType }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="attribute.attributeStyle"
                      >
                        <option
                          :value="item.id"
                          v-for="item in attributeStyles"
                          :key="item.id"
                        >
                          {{ item.label }}
                        </option>
                      </select>

                      <form-error
                        :model="$v.attribute.attributeStyle"
                        :label="translations.forms.labels.attributeType"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Poveži s artiklom?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="attribute.linkWithArticle"
                          id="link-with-article"
                        />
                        <label for="link-with-article"></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.attribute.attributeProperties.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.availableValues }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <draggable
                        :list="attribute.attributeProperties"
                        :disabled="false"
                        class="list-group"
                        ghost-class="ghost"
                        tag="ul"
                        handle=".handle"
                        @start="dragging = true"
                        @end="dragging = false"
                      >
                        <li
                          class="list-group-item"
                          v-for="(
                            element, index
                          ) in attribute.attributeProperties"
                          :key="index"
                        >
                          <i class="fa fa-align-justify handle"></i>
                          <input
                            type="text"
                            class="form-control"
                            v-model="element.title"
                            v-if="attribute.attributeStyle !== 1"
                          />
                          <v-swatches
                            v-model="element.title"
                            v-else
                            swatches="text-advanced"
                          ></v-swatches>
                          <i
                            class="fa fa-times close"
                            :class="{ color: attribute.attributeStyle === 1 }"
                            data-bs-toggle="modal"
                            data-bs-target="#delete-modal"
                            @click="selectIndex(element)"
                          ></i>
                        </li>
                      </draggable>

                      <form-error
                        :model="$v.attribute.attributeProperties"
                        :label="translations.forms.labels.availableValues"
                        :dirty="$v.$dirty"
                      />
                      <button
                        type="button"
                        class="
                          btn btn-primary
                          py-3
                          mt-2
                          align-items-center
                          font-weight-semibold
                          line-height-1
                        "
                        @click.prevent.stop="add()"
                      >
                        Add new
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-attribute-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'Attributes' }"
            class="
              cancel-button
              btn btn-light btn-px-4
              py-3
              border
              font-weight-semibold
              text-color-dark text-3
            "
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteAttribute }}</strong>
        </h5>
        <div slot="body">
          <span v-html="modalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteAttributeValue"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
      <modal id="delete-attribute-modal">
        <h5 slot="header"><strong>{{ translations.deleteAttribute }}</strong></h5>
        <div slot="body">
          <span v-html="modalAttributeText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="deleteAttribute" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import VSwatches from "vue-swatches";
// Import the styles too, typically in App.vue or main.js
import "vue-swatches/dist/vue-swatches.css";

import draggable from "vuedraggable";
import { translations } from "@/mixins";
import api from "@/services/api";
import validations from "./validation-schema/add";
import FormError from "../shared/form-errors/FormError.vue";
import Modal from "../shared/modal/Modal.vue";

export default {
  name: "EditAttribute",
  components: { FormError, Modal, draggable, VSwatches },
  mixins: [translations],
  validations: {
    attribute: validations,
  },
  data() {
    return {
      selectedAttribute: {},
      attributeStyles: [
        {
          id: 1,
          label: "Boja",
        },
        {
          id: 2,
          label: "Velicina odjeće",
        },
        {
          id: 3,
          label: "Ostalo",
        },
      ],
    };
  },
  computed: {
    attribute() {
      return this.$store.getters.getAttribute;
    },
    modalText() {
      return this.translations.areYouSureAttributeValue.replace(
        "{attributeValue}",
        `<strong>${this.selectedAttribute.title}</strong>`
      );
    },
    modalAttributeText() {
      return this.translations.areYouSureAttribute.replace(
        "{attribute}",
        `<strong>${this.attribute.title}</strong>`
      );
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  mounted() {
    this.$store.dispatch("getAttribute", this.$route.params.id);
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const { attribute } = this;

      attribute.attributeProperties = attribute.attributeProperties.map(
        (item, index) => {
          return {
            ...item,
            order: index + 1,
          };
        }
      );

      api
        .updateAttribute(attribute)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: "Attributes" });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    deleteAttributeValue() {
      this.removeAt(this.selectedAttribute);

      if (this.selectedAttribute.id) {
        api
          .deleteAttributeValue(this.selectedAttribute.id)
          .then((response) => {
            this.$toast.info(response.data.info);
          })
          .catch((err) => {
            this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          });
      }
    },
    deleteAttribute() {
      api.deleteAttribute(this.attribute.id).then((response) => {
        this.$toast.info(response.data.info);
        $('#delete-attribute-modal').modal('hide');
        this.$router.push({ name: "Attributes" });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
        $('#delete-attribute-modal').modal('hide');
      });
    },
    add: function () {
      this.attribute.attributeProperties.push({
        title: "",
        order: this.attribute.attributeProperties.length + 1,
      });
    },
    removeAt(selectedAttribute) {
      const index = this.attribute.attributeProperties.findIndex(
        (item) =>
          item.order === selectedAttribute.order &&
          item.title === selectedAttribute.title
      );
      this.attribute.attributeProperties.splice(index, 1);
    },
    selectIndex(attributeValue) {
      this.selectedAttribute = attributeValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  margin-top: 35px;
}

.handle {
  margin-right: 15px;
  cursor: grab;
}

.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}

.list-group-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.close {
  margin-left: 15px;

  &.color {
    position: absolute;
    right: 15px;
  }
}
</style>
